import '../../../Secondary/MarketsList/style.scss'
import useWindowDimensions from 'helpers/screen';
import CryptoIcon from 'components/Secondary/CryptoIcon';
import ChangeIndicator from 'components/Secondary/ChangeIndicator';
import './style.scss'

const mock = [
  {
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "BUY",
    type: "Limit",
    orderSize: 2.35,
    avgFillPrice: 123214124.43,
    fillValue: 79504.33
  },
  {
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "SELL",
    type: "Market",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },{
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "BUY",
    type: "Limit",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },
  {
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "SELL",
    type: "Market",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },{
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "BUY",
    type: "Limit",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },
  {
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "SELL",
    type: "Market",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },{
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "BUY",
    type: "Limit",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },
  {
    title: "BTC-USDC",
    date: "13:55 April 23, 2022",
    side: "SELL",
    type: "Market",
    orderSize: 2.35,
    avgFillPrice: 4553.43,
    fillValue: 79504.33
  },
]

const TradingHistoryTable = ({}) => {
  const {width} = useWindowDimensions();

  const minValue = (value) =>{
    let result = "$"
    if(value >= 1000000){
      result += (value/1000000).toFixed(1) + "m"
    }else if(value >= 1000){
      result += (value/1000).toFixed(1) + "k"
    }else{
      result += value
    }
    return result
  }

  return <div className='tradingHistoryTable'>
    <div className="marketsList">
      {width > 900 &&
        <div className="titles">
          <p>Trade</p>
          <p>Date</p>
          <p>Side</p>
          <p>Type</p>
          <p>OrderSize</p>
          <p>Avg. Fill Price</p>
          <p>Fill Value</p>
        </div>
      }
      <div className="table">
        {
          mock.map((item, i) => {
            return <div key={i} className="item">
              <div>
                {width <= 900 && <p>Trade</p>}
                <div className="flex">
                  <CryptoIcon symbol="BTC" size={16}/>
                  <p className="tickerName">{item.title}</p>
                </div>
              </div>
              <div>
                {width <= 900 && <p>Date</p>}
                <p className="date">{item.date}</p>
              </div>
              <div>
                {width <= 900 && <p>Side</p>}
                <p className={item.side === "BUY" ? "side" : "side red"}>{item.side}</p>
              </div>
              <div>
                {width <= 900 && <p>Type</p>}
                <p className="type">{item.type}</p>
              </div>
              <div>
                {width <= 900 && <p>OrderSize</p>}
                <p className="orderSize">{item.orderSize}</p>
              </div>
              <div>
                {width <= 900 && <p>Avg. Fill Price</p>}
                <p className="avgFillPrice">{width > 900 ? item.avgFillPrice : minValue(item.avgFillPrice)}</p>
              </div>
              <div>
                {width <= 900 && <p>Fill Value</p>}
                <p className="fillValue">{width > 900 ? item.fillValue : minValue(item.fillValue)}</p>
              </div>
            </div>
          })
        }
      </div>
    </div>
  </div>
}

export default TradingHistoryTable;